var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetHelpChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12h12v-2H4v2Zm0-3h12V7H4v2Zm0-3h12V4H4v2Zm16 14-4-4H2c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 0 14V2C0 1.45.196.98.588.587A1.926 1.926 0 0 1 2 0h16c.55 0 1.02.196 1.413.588C19.803.979 20 1.45 20 2v18ZM2 2v12h14.825L18 15.175V2H2Z",
    fill: "#2F42C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetHelpChat);
export default __webpack_public_path__ + "static/media/getHelp_chat.42b5d4e82667504a4f81cab44325be98.svg";
export { ForwardRef as ReactComponent };